//  Company
export const COMPANY_CREATE = 'add_company'
export const COMPANY_READ = 'view_company'
export const COMPANY_UPDATE = 'change_company'
export const COMPANY_DELETE = 'delete_company'
export const COMPANY_ACTIVATE = 'activate_company'
export const CRM_IMPORT = 'add_crm_company'

// Device Groups
export const DEVICE_GROUP_CREATE = 'add_device_group'
export const DEVICE_GROUP_UPDATE = 'change_device_group'
export const DEVICE_GROUP_DELETE = 'delete_device_group'

// Device Profiles
export const DEVICE_PROFILES_READ = 'view_device_profiles'

// Orders
export const ORDER_READ = 'view_order'

// Comm Modules
export const COMMODULE_CREATE = 'add_communicationdevice'
export const COMMODULE_READ = 'view_communicationdevice'
export const COMMODULE_DELETE = 'delete_communicationdevice'

// Transfers
export const TRANSFER_READ = 'view_transfer'
export const TRANSFER_CREATE = 'add_transfer'

// Measuring Points
export const MEASURINGPOINT_READ = 'view_measuringpoint'
export const MEASURINGPOINT_CREATE = 'add_measuringpoint'

// Users
export const USER_READ = 'view_user'
export const USER_CREATE = 'add_user'
export const USER_UPDATE = 'change_user'
export const USER_DELETE = 'delete_user'

// Tour Management
export const TOUR_MANAGEMENT = 'view_tour'
export const TOUR_IMPORT = 'add_tour'
export const TOUR_EXPORT = 'export_tour'
export const TOUR_ASSIGN = 'add_tablet'
export const TOUR_REASSIGN = 'change_tablet'
export const TOUR_RESTORE = 'change_tour'
export const TOUR_DISCARD = 'change_tour'
export const TOUR_DELETE = 'delete_tour'
export const TOUR_CLOSE = 'change_tour'
export const TABLETS_MANAGE = 'change_tablet'
export const TABLETS_VIEW ='view_tablet'

// Sonico
export const SONICO_PROFILE_CREATE = 'add_sonicoprofile'
